// Metric colors for retail. Teal is the brand/UI color (tabs, buttons, selection);
// data uses these so metrics don't read as brand accents or good/bad status.
export const DATA_COLOR = '#2563eb'; // primary metric (blue)
export const DATA_COLOR_ALT = '#7c3aed'; // second series (violet)
export const DATA_NEUTRAL = '#64748b'; // bars that are just magnitude (slate)
export const DATA_REST = '#cbd5e1'; // the "rest" of a split (light slate)
export const TRAFFIC_LINE = '#334155'; // traffic line drawn over phase bands
export const PURCHASE_COLOR = '#059669'; // conversion: purchased (distinct from the phase colors)

// Game day phases, in order. Same colors on the phase cards and the traffic chart bands.
export const PHASES = {
  pregame: { label: 'Pregame', color: '#8b5cf6', tint: 'rgba(139, 92, 246, 0.10)' },
  gates: { label: 'Gates open', color: '#f59e0b', tint: 'rgba(245, 158, 11, 0.12)' },
  game: { label: 'Game', color: '#2563eb', tint: 'rgba(37, 99, 235, 0.09)' },
};

// Zone heat colors: the same scale and cut-offs the store maps use, so a zone's
// color in a list always matches its color on the map.
export const HEAT = {
  low: 'rgb(122, 219, 92)',
  mid: 'rgb(245, 235, 84)',
  high: 'rgb(234, 170, 60)',
  top: 'rgb(218, 81, 70)',
};
export const HEAT_GRADIENT = `linear-gradient(to right, ${HEAT.low}, ${HEAT.mid}, ${HEAT.high}, ${HEAT.top})`;

// Live: fixed people counts. Analytics (averages): quartiles across zones.
export const zoneHeatColor = (value, allValues, isAnalytics) => {
  const v = value || 0;
  if (!isAnalytics) {
    if (v <= 4) return HEAT.low;
    if (v <= 8) return HEAT.mid;
    if (v <= 13) return HEAT.high;
    return HEAT.top;
  }
  const sorted = [...(allValues || [])].map((x) => x || 0).sort((a, b) => a - b);
  if (!sorted.length) return HEAT.low;
  const q = (p) => sorted[Math.floor(sorted.length * p)] || 0;
  if (v <= q(0.25)) return HEAT.low;
  if (v <= q(0.5)) return HEAT.mid;
  if (v <= q(0.75)) return HEAT.high;
  return HEAT.top;
};

// Dwell: thirds across zones (short, medium, long), as in the original zone list
export const dwellHeatColor = (value, allValues) => {
  const sorted = [...(allValues || [])].sort((a, b) => a - b);
  if (!sorted.length) return HEAT.low;
  const p33 = sorted[Math.floor(sorted.length * 0.33)] || 0;
  const p66 = sorted[Math.floor(sorted.length * 0.66)] || 0;
  if (value <= p33) return HEAT.low;
  if (value <= p66) return HEAT.high;
  return HEAT.top;
};
